<template>
    <div class="section-hero fit-height bg-brand">
        <div class="info inline bg-transparent grid xs-grid-cols-1 gap-3">
            <h1 class="f0 text-bold" v-html="data.title"></h1>
            <schoolsBreadcrumb :breadCrumb="data.breadCrumb" :isBanner="true" />
        </div>
    </div>
</template>

<script src="./schools-welcome.js"></script>
